import { render, staticRenderFns } from "./CommentKeyboard.vue?vue&type=template&id=d9e5ac02&scoped=true&"
import script from "./CommentKeyboard.vue?vue&type=script&lang=js&"
export * from "./CommentKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./CommentKeyboard.vue?vue&type=style&index=0&id=d9e5ac02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e5ac02",
  null
  
)

export default component.exports